module.exports = __webpack_public_path__ + "static/media/1.43d6c7c6.jpg";